"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../constants");
const elements_1 = require("../elements");
const translate_1 = require("../translate");
const REFERENCE_CARD_STYLES = {
    'no-answer': { design: 'default', name: 'UserIcon' },
    'not-recommended': { design: 'error', name: 'ThumbDownIcon' },
    recommended: { design: 'success', name: 'ThumbUpIcon' },
};
const StyledSmallCard = (0, styled_1.default)(elements_1.SmallCard)((props) => props.disabled
    ? {
        backgroundColor: constants_1.Color.LIGHT_GREY,
        cursor: 'not-allowed',
        opacity: 0.3,
        pointerEvents: 'none',
    }
    : {});
const ReferenceCard = ({ button, disabled, hideResponse, onClick, reference, }) => {
    const { answerCount, attachmentCount, completedAt, createdAt, isManaged, name, workplaceRelationshipToApplicant, } = reference;
    const t = (0, translate_1.useTranslations)();
    const answersSummary = hideResponse
        ? undefined
        : [
            answerCount &&
                t.candidate_view.references.n_questions_answered(answerCount),
            attachmentCount &&
                t.candidate_view.references.n_attachments(attachmentCount),
        ]
            .filter(utils_1.isTruthy)
            .join(', ');
    const status = hideResponse ? 'no-answer' : reference.status;
    const cardStyle = REFERENCE_CARD_STYLES[status];
    const isWaitingForResponse = !isManaged && !completedAt;
    const description = hideResponse || isWaitingForResponse
        ? `${t.candidate_view.references.added_at(t.$date.unix(createdAt).fromNow())}${hideResponse
            ? ''
            : `, ${t.candidate_view.references
                .waiting_for_response()
                .toLowerCase()}`}`
        : t.candidate_view.references.reported_at(t.$date.unix(createdAt).fromNow(), reference.isManaged);
    return ((0, jsx_runtime_1.jsx)(StyledSmallCard, { buttonDesign: button?.design, buttonIcon: button?.iconName, description: (0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, gap: 2, children: [(0, jsx_runtime_1.jsx)(elements_1.SmallCard.Description, { children: description }), answersSummary && ((0, jsx_runtime_1.jsx)(elements_1.SmallCard.Description, { children: answersSummary }))] }), design: cardStyle.design, disabled: disabled, icon: cardStyle.name, onButtonClick: button?.onClick, onClick: () => onClick(reference), title: name, subtitle: workplaceRelationshipToApplicant && ((0, jsx_runtime_1.jsx)(elements_1.Badge, { color: "blue", size: "sm", children: t.$workPlaceRelationshipToApplicant(workplaceRelationshipToApplicant) })) }));
};
exports.ReferenceCard = ReferenceCard;
